import { useState } from 'react'
import { useAuth } from '@talktoast/shared'
import DevFeedbackModal from './DevFeedbackModal'

/**
 * Dev FAB (Floating Action Button)
 * Allows authorized users to submit bug reports and feature requests
 * Only visible to users with matching VITE_DEV_FAB_ALLOWED_SUPABASE_USER_ID
 */
export default function DevFab() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { user } = useAuth()

  // Check if current user is allowed to see dev FAB
  const allowedUserId = import.meta.env.VITE_DEV_FAB_ALLOWED_SUPABASE_USER_ID
  const isAllowed = user?.id === allowedUserId

  // DEBUG: Log the comparison (remove after debugging)
  console.log('[DevFab Debug]', {
    allowedUserId,
    currentUserId: user?.id,
    isAllowed,
    hasUser: !!user
  })

  // Don't render if user is not allowed
  if (!isAllowed) {
    return null
  }

  return (
    <>
      {/* FAB Button */}
      <button
        onClick={() => setIsModalOpen(true)}
        className="fixed bottom-20 right-4 z-50 bg-red-600 hover:bg-red-700 text-white rounded-full p-4 shadow-lg transition-all hover:scale-110 active:scale-95"
        title="Report Bug / Request Feature"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </button>

      {/* Feedback Modal */}
      <DevFeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  )
}
